/* Breakpoints */
const tablet = 1050;
const smartphone = 700;
const small = 550;

/* Screen width */
let widthScreen = window.screen.width;

(function($) {
  if (!document.cookie.match(/^(.*;)?\s*produtos-naturais-dimissed\s*=\s*[^;]+(.*)?$/)) {
    $('.produtos-madeira-natural-container').addClass('sticky');
    setTimeout(function() {
      $('.produtos-madeira-natural-container').addClass('visible');
    }, 1000)
  }


  $('.mobile-menu-button').on('click', function() {
    $(this).toggleClass('open');
    $('.main-navbar').toggleClass('open');
    $('body').toggleClass('no-scroll');
  });

  //Janela flutuante da página de produtos
  $('.dimiss-button').on('click', function() {

    if (!$(".produtos-madeira-natural-container").hasClass("not-floating")) {
      $('.produtos-madeira-natural-container').addClass('hide');
      $(this).addClass('hide')

      setTimeout(function() {
        $('.produtos-madeira-natural-container').removeClass('hide');
        $('.produtos-madeira-natural-container').removeClass('sticky');
        $('.produtos-madeira-natural-container').addClass('not-floating');
      }, 400)

      document.cookie = 'produtos-naturais-dimissed=true; path=/';
    }

  });


  var observer = new IntersectionObserver(function(entries) {

    if (entries[0].intersectionRatio > 0) {
      $('.produtos-madeira-natural-container').addClass('not-floating')
      $('.dimiss-button').addClass('hide');
    }
  }, { threshold: [0, 1] });

  observer.observe(document.querySelector(".footer"));




  const submenuToggle = $('.main-menu .menu-item-has-children').find('> a')

  submenuToggle.on('click', function(e) {
    e.preventDefault()

    $(this).parent().toggleClass('active');

    let submenu = $(this).next('ul');

    if ($(this).parent().hasClass('active') && submenu.length) {
      submenu.height(submenu.prop("scrollHeight"));
    }
    else {
      submenu.height(0);
    }
  });

  /* ------------------------ */

  const behavior = function(val) {
      return val.replace(/\D/g, '').length === 11 ? '(00) 0 0000-0000' : '(00) 0000-00009';
    },
    options = {
      onKeyPress: function(val, e, field, options) {
        field.mask(behavior.apply({}, arguments), options);
      }
    };

  $('#newsWhatsapp').mask(behavior, options);

  const slickSettings = {
    infinite: true,
    speed: 400,
    prevArrow: $('.prevArrow'),
    nextArrow: $('.nextArrow'),
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    variableWidth: true,
    dots: true
  }

  $('.slider-container').slick(slickSettings);

  $('.mobile-share-button').on('click', share)

  function share() {
    const url = $(this).data('url')
    const title = $(this).data('title')

    const data = {
      title: title,
      text: title,
      url: url
    }

    const canShare = navigator.canShare(data)

    if (canShare) {
      navigator.share(data)
    }
    else {
      navigator.clipboard.writeText(url)
        .then(() => {
          alert('Link copiado para área de transferência')
        })
    }
  }

  // Form

  $('.wpcf7').on('submit', function() {
    $('.wpcf7 .main-button .default-message').addClass('hidden')
    $('.wpcf7 .main-button .sending-message').removeClass('hidden')
    $('.wpcf7 .main-button').attr('disabled', true)
  })

  $('.wpcf7').on('wpcf7submit', function() {
    $('.wpcf7 .main-button .default-message').removeClass('hidden')
    $('.wpcf7 .main-button .sending-message').addClass('hidden')
    $('.wpcf7 .main-button').attr('disabled', false)
  })

  // Clamp article text

  function clampArticle() {
    $('.article-title h3').each(function(index, element) {
      $clamp(element, { clamp: 2, useNativeClamp: false });
    });

    $('.news-abstract').each(function(index, element) {
      $clamp(element, { clamp: 3, useNativeClamp: false });
    });

    $('.event-abstract').each(function(index, element) {
      $clamp(element, { clamp: 4, useNativeClamp: false });
    });
  }

  $(function() {
    clampArticle()
  });

  $(window).resize(function() {
    clampArticle()
  })

  // Produtos Ambientados
  $('.ambient .slider').slick(slickSettings);

})(jQuery);

function redirectCategoria() {

  const categoriaLink = document.getElementById("select-categorias-produtos").value;

  if (categoriaLink == 'all') {
    window.location.href = 'brixner/produtos';
  }
  else {
    window.location.href = redirectCategoriaURL + "/categorias/" + categoriaLink;
  }
}
